const definePlugin = (plugin) => plugin;
export {
  definePlugin
};
//# sourceMappingURL=definePlugin.js.map
